<!--The content below is only a placeholder and can be replaced.-->
@if (loginDisplay) {
  <fdb-navigation></fdb-navigation>
  @if (!isIframe) {
    <router-outlet></router-outlet>
  }
}
@if (!loginDisplay) {
}


